import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit';

export const caMortgageDiscountSellActivate = (buttonLocation: string, deviceType: TDeviceType) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'MortgageDiscountSellLanding',
    label: 'MortgageDiscountSellActivate',
    page: {
      pageType: 'MortgageDiscountSellLanding',
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
      extra: {
        button_location: buttonLocation,
      },
    },
  });
};

export const caMyOffers = (deviceType: TDeviceType) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'MortgageDiscountSellLanding',
    label: 'MyOffers',
    page: {
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
      pageType: 'MortgageDiscountSellLanding',
    },
  });
};

export const caQuestionGroup = (questionGroup: string, deviceType: TDeviceType) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'MortgageDiscountSellLanding',
    label: 'question_group',
    page: {
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
      pageType: 'MortgageDiscountSellLanding',
      extra: {
        question_group: questionGroup,
      },
    },
  });
};

export const caQuestion = (questionGroup: string, question: string, deviceType: TDeviceType) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'MortgageDiscountSellLanding',
    label: 'question',
    page: {
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
      pageType: 'MortgageDiscountSellLanding',
      extra: {
        question_group: questionGroup,
        question,
      },
    },
  });
};

export const caPlayVideo = (deviceType: TDeviceType) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'MortgageDiscountSellLanding',
    label: 'play_video',
    page: {
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
      pageType: 'MortgageDiscountSellLanding',
    },
  });
};
